var React = require('react');

function IconClose24x24 (props) {
    return React.createElement("svg",props,React.createElement("g",{"id":".Close Base"},React.createElement("path",{"id":"Path","fillRule":"evenodd","clipRule":"evenodd","d":"M20 20L4 4L20 20ZM20 4L4 20L20 4Z","stroke":"#142B6F","strokeWidth":"1.5","strokeLinecap":"round","strokeLinejoin":"round"})));
}

IconClose24x24.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none"};

module.exports = IconClose24x24;

IconClose24x24.default = IconClose24x24;
